import { render, staticRenderFns } from "./TopProductsTable.vue?vue&type=template&id=5faa471e&scoped=true"
import script from "./TopProductsTable.vue?vue&type=script&lang=js"
export * from "./TopProductsTable.vue?vue&type=script&lang=js"
import style0 from "./TopProductsTable.vue?vue&type=style&index=0&id=5faa471e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa471e",
  null
  
)

export default component.exports